var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"standard-editor-page"},[_c('standard-editor',{attrs:{"file-id":_vm.fileId,"file-name":_vm.fileName,"preset":_vm.preset},on:{"save-requested":_vm.handleSave,"submit-requested":_vm.handleSubmit,"review-completed":_vm.handleReviewCompleted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }